import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["message", "type"];
import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedNumber from 'I18n/components/FormattedNumber';
import { isAlertMessage, isApiErrorMessage, isErrorMessage } from '../types/types';
import { jsx as _jsx } from "react/jsx-runtime";
export const handleClose = (message, onClose) => {
  if (isErrorMessage(message)) {
    if (message.error === 'IFrame initialization failed') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.errorInitFailed"
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error === 'saveLineItemsError') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.saveLineItemsError"
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error === 'saveContractLineItemsError') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.saveContractLineItemsError"
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error === 'ASSOCIATION_LIMIT_EXCEEDED_CREATOR') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "lib.creatorAssociationLimitExceededError",
          options: {
            objectName: message.objectName,
            toObjectName: message.toObjectName,
            limit: /*#__PURE__*/_jsx(FormattedNumber, {
              value: message.limit ? +message.limit : 50000
            })
          }
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error === 'USER_DOES_NOT_HAVE_PERMISSION') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.noPermissionsToAssociate"
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error === 'associationCreateFailures') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associationCreateFailures",
          options: {
            objectName: message.objectName
          }
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error === 'marketableContactAssociationError') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.marketableContactAssociationError"
        }),
        type: 'danger'
      });
      return;
    }
  }
  if (isApiErrorMessage(message)) {
    if (message.error.responseJSON.errorType === 'LimitExceededException') {
      const limit = message.error.responseJSON.errorTokens.limit[0];
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "lib.createLimitExceededError",
          options: {
            limit: /*#__PURE__*/_jsx(FormattedNumber, {
              value: Number(limit)
            }),
            objectName: message.objectName
          }
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error.responseJSON.message === 'ASSOCIATION_LIMIT_EXCEEDED') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associationLimitExceededError",
          options: {
            fromObjectName: message.fromObjectName,
            toObjectName: message.objectName
          }
        }),
        type: 'danger'
      });
      return;
    }
    if (message.error.responseJSON.message === 'CRM_OBJECT_NOT_FOUND') {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associatorNoObjectFound",
          options: {
            objectName: message.objectName
          }
        }),
        type: 'danger'
      });
      return;
    }
  }
  if (isErrorMessage(message) && message.error === 'ASSOCIATION_USER_CONFIG_LIMIT_EXCEEDED' || isApiErrorMessage(message) && message.error.responseJSON.message === 'ASSOCIATION_USER_CONFIG_LIMIT_EXCEEDED') {
    if (message.specHasAllAssociatedObjects) {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associationUserConfigLimitExceededError"
        }),
        type: 'danger'
      });
    } else {
      FloatingAlertStore.addAlert({
        message: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "lib.associationUserConfigLabelLimitExceededError"
        }),
        type: 'danger'
      });
    }
    return;
  }
  if (isAlertMessage(message)) {
    const _message$alert = message.alert,
      {
        message: alertMessage,
        type
      } = _message$alert,
      rest = _objectWithoutPropertiesLoose(_message$alert, _excluded);
    FloatingAlertStore.addAlert(Object.assign({
      message: alertMessage,
      type,
      'data-alert-type': type
    }, rest));
    return;
  }
  onClose(message);
};